import React from 'react'
import PropTypes from 'prop-types'

export default function PreviousIcon(props) {
  let iconProps = {
    ...props,
    hovered: props.hovered.toString(),
  }
  let iconStyles = {
    color: '#404040',
    fill: '#fafafa'
  }
  if (props.disabled) {
    iconStyles = {
      color:'#5d5d5d',
      fill: '#404040'
    }
  } else if (props.hovered) {
    iconStyles = {
      color: '#f37735',
      fill: '#fafafa'
    }
  }
  iconProps = {
    ...iconProps,
    ...iconStyles
  }
  return (
    <svg width={iconProps.width} height={iconProps.height} viewBox='0 0 40 33' fill='none' xmlns='http://www.w3.org/2000/svg' {...iconProps}>
      <rect x='40' y='32.5' width='40' height='33' rx='16' transform='rotate(-180 40 32.5)' fill={iconProps.fill} />
      <path d='M18.8281 16.4998L23.7781 21.4498L22.3641 22.8638L16.0001 16.4998L22.3641 10.1358L23.7781 11.5498L18.8281 16.4998Z' fill={iconProps.color} />
    </svg>
  )
}

PreviousIcon.propTypes = {
  disabled: PropTypes.bool,
  height: PropTypes.number,
  hovered: PropTypes.bool,
  width: PropTypes.number
}

PreviousIcon.defaultProps = {
  disabled: false,
  height: 40,
  hovered: false,
  width: 40
}
